import { css } from 'src/styles/theme';
import { IInputProps } from './Input';

export const StylesOV = css<IInputProps>``;
